import { createPostApi } from 'api/post';
import { VisibilityType } from 'interfaces/CF';

const shareFeedbackNew = async ({
  body,
  visibility,
  feedbackSentimentType,
}: {
  body: Record<string, any>;
  visibility: VisibilityType;
  feedbackSentimentType: 'APPRECIATIVE' | 'CONSTRUCTIVE';
}) => {
  try {
    const feedbackType = feedbackSentimentType === 'APPRECIATIVE' ? 'KUDOS' : 'FEEDBACK';
    await createPostApi(body, feedbackType, visibility);
  } catch (error) {
    console.error('Error sharing feedback : ', error);
  }
};

export default shareFeedbackNew;
